<template>
  <div class="sprinframe" ref="Trans" v-show="transShow">
    <div class="sprin-top">
      <div class="inpdiv">
        <input @keyup.enter="searchValue" class="input" type="text" placeholder="搜索英文单词" v-model="newValue" />
        <div class="img"  >
          <img @click="searchValue" class="imgicon"
            src="https://jingyouxue-student-web.oss-cn-hangzhou.aliyuncs.com/content/magnifier_icon1.png" alt="" />
        </div>
      </div>
      <!-- <div class="bockIcon">
        <img
          class="bockImg"
          src="https://jingyouxue-student-web.oss-cn-hangzhou.aliyuncs.com/content/study_icon1.png"
          alt=""
        />
        <div class="bockText">学习</div>
      </div> -->
      <div class="icon" @click="cleTranslation">X</div>
    </div>

    <div v-if="nullText && newdata">
      <div class="flamesLis">
        <div class="flames">
          <img class="flamesImg" src="https://jingyouxue-student-web.oss-cn-hangzhou.aliyuncs.com/content/flames-icon.png"
            alt="" />
        </div>
        <div class="flamesText">词频6次</div>
      </div>
      <div class="change" v-show="!changeAdd" @click="clichangeAdd(1)">
        <img class="changeImg" src="https://jingyouxue-student-web.oss-cn-hangzhou.aliyuncs.com/content/addto-icon.png"
          alt="" />
        <div class="changeText">加入单词本</div>
      </div>
      <div class="change" v-show="changeAdd" @click="clichangeAdd(2)">
        <img class="changeImg" src="https://jingyouxue-student-web.oss-cn-hangzhou.aliyuncs.com/content/addto2-icon.png"
          alt="" />
        <div class="changeText">取消收藏</div>
      </div>
      <div class="word">
        <div class="wordEn">
          {{ newdata.query }}
          <img @mouseover="hoveimg = false" v-show="hoveimg && newdata.basic.phonetic" class="wordEnIcon"
            src="https://jingyouxue-student-web.oss-cn-hangzhou.aliyuncs.com/content/voice_icon0.png" alt="" />
          <img @click="playAudio" @mouseout="hoveimg = true" v-show="!hoveimg" class="wordEnIcon"
            src="https://jingyouxue-student-web.oss-cn-hangzhou.aliyuncs.com/content/voice_icon1.png" alt="" />
        </div>
        <div class="symbols" v-if="newdata.basic.phonetic">
          [{{ newdata.basic.phonetic }}]
        </div>
        <div class="symbols" v-else>没有查到此单词的读音</div>
        <div class="wordCh">
          <span v-if="newitem" v-for="(newitem, newindex) in newdata.basic.explains" :key="newindex">{{ newitem }}</span>
          <span v-else>这个单词的释义飞走了哟</span>
        </div>
      </div>
    </div>
    <div class="transNull" v-if="!nullText">
      <img class="nullImg" src="https://jingyouxue-student-web.oss-cn-hangzhou.aliyuncs.com/content/imgNull.png" alt="" />
      <div class="nullText">没有查到需要的单词</div>
    </div>
  </div>
</template>

<script>
import {
  postGetWord,
  postHearingCollection,
  delIeltsHearingCollectionVocabulary,
  getIeltsHearingCollectionVocabulary,
  getHearingCollectionWord,
  postIeltsHearingCollectionWord,
  delIeltsCollectionWord
} from "../../utils/api";
export default {
  props: ["name", "page",  "transShow"],
  data() {
    return {
      changeAdd: false,
      newdata: null,
      hoveimg: true,
      audio: null,
      nullText: false,
      newValue: null,
      collectionList: [],
      mainItem: null,
    };
  },
  mounted() {
    console.log(this.page, this.name,  '参数');
    this.getBookmarkStatus();

    // this.postGetWordFn().then(() => {
    //   // this.getieltsHearingCollectionFn();
    // });

    // document.addEventListener("mousewheel", (e) => {
    //   this.cleTranslation();
    // });
  },
  methods: {
    async searchValue() {
      //搜索单词
      const text = this.newValue.trim();
      if (text != "" && text != null) {
        const result = await getHearingCollectionWord(text);
        if (result.data) {
          this.mainItem = result.data;
          this.newdata = result.data.studentWord;
          this.nullText = true;
          this.changeAdd = result.data.collect;
          console.log("查到单词了");
        } else {
          this.newdata = null
          this.nullText = false;
        }
        this.newValue = null;
        console.log(result);
      } else {
        this.newValue = null;
        this.nullText = false;
        console.log("搜索不能为空");
      }
    },
    cleTranslation() {
      //关闭弹窗
      if (this.audio != null) {
        this.audio.pause();
      }
      this.$emit("cliTrans");
    },
    playAudio() {
      //播放音频
      this.audio = new Audio();
      this.audio.src = this.newdata.speakUrl;
      this.audio.play();
    },
    clichangeAdd(num) {
      console.log(this.newdata, "添加收藏");
      //添加删除收藏单词
      // this.changeAdd=!this.changeAdd
      if (num == 1) {
        const _obj = {
          wrong: 3,
          studentWordId: this.newdata.id,
          studentWordName: this.newdata.query
        }
        postIeltsHearingCollectionWord(_obj).then((res) => {
          if (res.code === 200) {
            this.changeAdd = true;
            this.cleTranslation();
          } else {
            console.log(res.msg);
          }
        });
      } else {
        if (this.mainItem.collectId) {
          delIeltsCollectionWord(this.mainItem.collectId).then((res) => {
            console.log(res, "删除收藏");
            if(res.code ===200){
              this.changeAdd = false;
              this.cleTranslation();
            }
          });
        }
      }
    },
    async getBookmarkStatus() {
      //获取单词翻译
      const text = this.name.replace(":", "").replace(",", "");
      console.log(text);
      if (text != "" && text != null) {
        const result = await getHearingCollectionWord(text);
        if (result.data) {
          this.mainItem = result.data;
          this.newdata = result.data.studentWord;
          this.nullText = true;
          this.changeAdd = result.data.collect;
        } else {
          this.nullText = false;
        }
      }
    },
    async postieltsHearingCollectionFn() {
      //添加收藏
      console.log(this.newdata.query);
      const data = { text: this.newdata.query };
      const result = await postHearingCollection(2, data);
      // // console.log(result,"添加收藏");
      this.$emit("resLis");
    },
    async deleteieltsHearingCollectionFn() {
      //删除收藏

      // const res = this.collectionList.some((item) => {
      //   if (this.newdata.query == item.jsonData) {
      //     return item;
      //   }
      // });
      let _item;
      this.collectionList.forEach((element) => {
        if (element.jsonData == this.newdata.query) {
          _item = element;
        }
      });
      // console.log(_item.id);
      const studentWordId = _item.id * 1;
      const result = await delIeltsHearingCollectionVocabulary(studentWordId);
      // // console.log(result,"删除收藏");
      this.$emit("resLis");
    },
    //给文章的生词打标
    async getieltsHearingCollectionFn() {
      //获取收藏列表
      const result = await getIeltsHearingCollectionVocabulary(2);
      console.log(result.data, this.newdata, "结果");
      this.collectionList = result.data;
      const res = result.data.some((item) => {
        return this.newdata.query == item.jsonData;
      });
      const res1 = result.data.some((item) => {
        //拿name判断
        return this.name == item.jsonData;
      });
      res1 ? (this.changeAdd = true) : (this.changeAdd = false);
      return res;
    },
  },
  computed: {},
  watch: {
    name() {
      this.getBookmarkStatus();
    },
    page(val) {
      this.$nextTick(async () => {
        this.$refs.Trans.style.top = val.pageY + 10 + "px";
        this.$refs.Trans.style.left = val.pageX + 10 + "px";
        // const result = await this.getieltsHearingCollectionFn();
        // if(result==false){
        //   this.postieltsHearingCollectionFn()
        //   this.$emit("resLis")
        //   this.changeAdd=true
        // }
      });
    },
  },
};
</script>

<style  lang="css" scoped>
.nullImg {
  width: 115px;
  height: 91px;
  display: block;
  margin: 20px auto 20px;
}

.transNull .nullText {
  font-size: 12px;
  color: #999999;
  text-align: center;
}

.wordEnIcon {
  width: 12.22px;
  height: 10.49px;
  margin-bottom: 10px;
  cursor: pointer;
}

.sprinframe {
  width: 318px;
  min-height: 268px;
  /* height: 268px; */
  background-color: #ffffff;
  position: absolute;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  z-index: 999;
  padding-bottom: 20px;
}

.sprinframe .sprin-top {
  height: 60px;
  line-height: 60px;
  border-radius: 4px;
  background-color: #f6f7f9;
  display: flex;
  justify-content: space-around;
  text-align: center;
}

.inpdiv .input {
  width: 200px;
  height: 28px;
  border: 1px solid #f6f7f9;
  padding-left: 20px;
  border-radius: 2px;
}

.inpdiv .input:hover {
  border: 1px solid #ec8217;
}

.inpdiv .input:focus {
  outline: 1px solid #ec8217;
}

.inpdiv {
  position: relative;
}

.inpdiv .img {
  width: 30px;
  height: 17px;
  border-left: 1px solid #d6d6d6;
  position: absolute;
  top: 22px;
  right: 0px;
  cursor: pointer;
  border-radius: 2px;
}

.imgicon {
  width: 14px;
  height: 14px;
  display: block;
  margin: 2px auto 0px;
}

/* .bockIcon {
  width: 60px;
  height: 28px;
  line-height: 28px;
  background-color: #cccccc;
  margin-top: 18px;
  cursor: pointer;
  border-radius: 2px;
}
.bockIcon:hover {
  color: #fff;
  background-color: #198669;
}
.bockIcon .bockImg {
  width: 18.03px;
  height: 15.65px;
  display: block;
  float: left;
  margin: 6px 7px 0;
} */
.bockText {
  height: 17px;
  font-size: 12px;
  float: left;
}

.sprin-top .icon {
  width: 19.98px;
  height: 19.97px;
  margin-top: 4px;
  font-size: 18px;
  cursor: pointer;
}

.sprin-top .icon:hover {
  color: #ec8217;
}

.flamesLis {
  width: 74px;
  height: 14px;
  margin: 8px 0 0 10px;
}

.flames {
  width: 13px;
  height: 14px;
  line-height: 14px;
  text-align: center;
  background-color: #ff0000;
  float: left;
}

.flames .flamesImg {
  width: 7.6px;
  height: 8.76px;
  margin: 0 auto 2px;
}

.flamesText {
  width: 44px;
  height: 12px;
  line-height: 14px;
  border: 1px solid #ff0000;
  float: left;
  font-size: 10px;
  color: #ff0000;
  text-align: center;
}

.change {
  float: right;
  text-align: center;
  margin-right: 8px;
  cursor: pointer;
}

.change .changeImg {
  width: 21px;
  height: 21px;
  margin-bottom: 3px;
}

.change .changeText {
  font-size: 12px;
}

.word .wordEn {
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  margin: 44px 0px 0px;
}

.word .symbols {
  text-align: center;
  font-size: 12px;
  color: #999999;
  margin: 22px 0px;
}

.word .wordCh {
  width: 200px;
  font-size: 14px;
  text-align: center;
  margin: auto;
  /* white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; */
}
</style>



// WEBPACK FOOTER //
// src/components/TranslationBulletIelts/index.vue